export default (router, store) => {
    router.beforeEach((to, from, next) => {
        if (to.meta.permission && !store.state.authenticated) {
            return next('/');
        }

        const permissoesRota = to.meta.permission;
        const permissoesLogin = store.state.permissions;

        if (permissoesRota && permissoesRota.length > 0
            && permissoesLogin.filter(p => permissoesRota.includes(p)).length === 0) {
            router.push('/erro-acesso-negado');
            return;
        }
        next();
    })
}
